export const ATTACH_FILE_TO_ENGAGEMENT = 'ATTACH_FILE_TO_ENGAGEMENT';
export const OPEN_ATTACHMENT_FILE_MANAGER = 'OPEN_ATTACHMENT_FILE_MANAGER';